import moment from 'moment';
export const getTime = (time, format) => {
    if (!time) {
        return '-';
    }
    return moment(time).format('YYYY-MM-DD' || format);
};

export const getMMSS = (seconds) => {
    if (seconds === undefined) {
        return false;
    }
    let minutes = `0${Math.floor(seconds / 60)}`.slice(-2);
    let second = `0${Math.floor(seconds % 60).toFixed(0)}`.slice(-2);

    return `${minutes}:${second}`;
};
export const timeTransforStr = (timeMills) => {
    return timeMills ? moment(new Date(parseInt(timeMills))).format('YYYY-MM-DD HH:mm') : '--';
};

export const formatTime = (timeMills, pattern_str) => {
    return timeMills ? moment(new Date(parseInt(timeMills))).format(pattern_str) : '--';
};
export const timeTransforTodayNoYear = (timeStamp) => {
    const currentDateTime = new Date();
    const currentYear = currentDateTime.getFullYear();
    const currentMonth = currentDateTime.getMonth() + 1; // 月份从 0 开始，因此需要加 1
    const currentDate = currentDateTime.getDate();

    const paramsDateTime = new Date(parseInt(timeStamp ? timeStamp : '0'));
    const paramsYear = paramsDateTime.getFullYear();
    const paramsMonth = paramsDateTime.getMonth() + 1; // 月份从 0 开始，因此需要加 1
    const paramsDate = paramsDateTime.getDate();
    if (currentYear === paramsYear && currentMonth === paramsMonth) {
        if (currentDate === paramsDate) {
            return '今天';
        } else if (currentDate - paramsDate === 1) {
            return '昨天';
        } else if (currentDate - paramsDate === -1) {
            return '明天';
        }
        return `${paramsMonth}月${paramsDate}日`;
    }
    return `${paramsMonth}月${paramsDate}日`;
};
export const convertTimeToMinutesSeconds = (timestamp) => {
    var minutes = Math.floor(timestamp / (1000 * 60));
    var seconds = ((timestamp % (1000 * 60)) / 1000).toFixed(0);
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return minutes + ' 分 ' + seconds + ' 秒';
};
export const convertSecondsToHMS = (seconds) => {
    const duration = moment.duration(seconds, 'seconds');
    const hours = ('0' + duration.hours()).slice(-2);
    const minutes = ('0' + duration.minutes()).slice(-2);
    const secondsLeft = ('0' + duration.seconds()).slice(-2);

    return `${hours}: ${minutes}: ${secondsLeft}`;
};
export const timeTransforTodayNoYearTime = (timeStamp) => {
    const currentDateTime = new Date();
    const currentYear = currentDateTime.getFullYear();
    const currentMonth = currentDateTime.getMonth() + 1; // 月份从 0 开始，因此需要加 1
    const currentDate = currentDateTime.getDate();

    const paramsDateTime = new Date(parseInt(timeStamp ? timeStamp : '0'));
    const paramsYear = paramsDateTime.getFullYear();
    const paramsMonth = paramsDateTime.getMonth() + 1; // 月份从 0 开始，因此需要加 1
    const paramsDate = paramsDateTime.getDate();
    const paramsHours = paramsDateTime.getHours();
    const paramsMinutes = paramsDateTime.getMinutes();
    if (currentYear === paramsYear && currentMonth === paramsMonth) {
        if (currentDate === paramsDate) {
            return '今天';
        } else if (currentDate - paramsDate === 1) {
            return `昨天 ${paramsHours}:${paramsMinutes}`;
        } else if (currentDate - paramsDate === -1) {
            return '明天';
        }
        return `${paramsMonth}月${paramsDate}日`;
    }
    return `${paramsMonth}月${paramsDate}日`;
};

export const convertSecondsToHMSLive = (seconds) => {
    if (isNaN(seconds) || seconds < 0) {
        return '00:00:00'; // 处理无效输入
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = hours >= 100 ? String(hours) : ('0' + hours).slice(-2);
    const formattedMinutes = ('0' + minutes).slice(-2);
    const formattedSeconds = ('0' + remainingSeconds).slice(-2);

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const liveTime = (startTime, endTime) => {
    let time;
    if (startTime && endTime) {
        const date1 = new Date(startTime),
            date2 = new Date(endTime),
            // 判断是否跨天
            isCrossDay = date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth() || date1.getDate() !== date2.getDate();
        if (isCrossDay) {
            time =
                moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm:ss') + ' 至 ' + moment(new Date(parseInt(endTime))).format('YYYY-MM-DD HH:mm:ss');
        } else {
            time = moment(new Date(parseInt(startTime))).format('YYYY-MM-DD HH:mm:ss') + ' 至 ' + moment(new Date(parseInt(endTime))).format('HH:mm:ss');
        }
    } else {
        time = '';
    }

    return time;
};

export const isInTargetTimeRange = () =>{
    const baseDate = moment('2026-02-06', 'YYYY-MM-DD');
    const startTime = baseDate.clone().hour(21).minute(0).second(0); // 开始时间
    const endTime = baseDate.clone().add(1, 'day').hour(12).minute(0).second(0); // 结束时间
    const now = moment();
    const isInRangeWithBorder = now.isSameOrAfter(startTime) && now.isSameOrBefore(endTime);
    return isInRangeWithBorder;
};
export const tencentMeetingTimeFormat = (startTime, endTime) => {
    // 参数验证
    if (!startTime || !endTime) {
        return '';
    }
    try {
        // 转换为时间戳
        const startTimestamp = parseInt(startTime);
        const endTimestamp = parseInt(endTime);
        // 验证时间戳有效性
        if (isNaN(startTimestamp) || isNaN(endTimestamp)) {
            return '';
        }
        // 使用 moment 处理时间
        const startMoment = moment(startTimestamp);
        const endMoment = moment(endTimestamp);
        // 判断是否跨年
        const isCrossYear = startMoment.year() !== endMoment.year();
        // 判断是否跨天
        const isCrossDay = !startMoment.isSame(endMoment, 'day');
        let time = '';
        // 跨年处理
        if (isCrossYear) {
            time = `${startMoment.format('YYYY-MM-DD HH:mm')} 至 ${endMoment.format('YYYY-MM-DD HH:mm')}`;
        } else if (isCrossDay) {
            // 跨天处理
            time = `${startMoment.format('YYYY-MM-DD HH:mm')} 至 ${endMoment.format('MM-DD HH:mm')}`;
        } else {
            // 不跨天处理
            time = `${startMoment.format('YYYY-MM-DD HH:mm')} 至 ${endMoment.format('HH:mm')}`;
        }
        return time;
    } catch (error) {
        console.error('时间格式化错误:', error);
        return '';
    }
};